import React from 'react';
import './Footer.css'; 
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-section footer-about">
          <h3>About Us</h3>
          <p>
            We are dedicated to providing the best service possible. Our mission is to deliver quality and value.
          </p>
        </div>

        
        <div className="footer-section footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        
        <div className="footer-section footer-contact">
          <h3>Contact Us</h3>
          <p>Email: zainullahtawakuli33@gmail.com</p>
          <p>Phone: +93 (744) 359 667 </p>
          <div className="footer-social">
            <a href="https://www.facebook.com" aria-label="Facebook"><FaFacebookF /></a>
            <a href="https://www.twitter.com" aria-label="Twitter"><FaTwitter /></a>
            <a href="https://www.istagram.com" aria-label="Instagram"><FaInstagram /></a>
            <a href="https://www.linkedin" aria-label="LinkedIn"><FaLinkedinIn /></a>
          </div>
        </div>
      </div>

      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Your Company. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
